import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO1_END = {
  title: "Find out more about Infosys Business \nOperations from our staff.",
  bgImage: "ILO/ILO1/ILO_demo_bg_end.jpg",
  optionsButtons: [
    {
      label: "Overview",
      onClick: () => setCurrentPage("ILO_101"),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage("ILO_104"),
      endIcon: "arrow-right",
    },
  ],
};

export default DATA_NO_DEMO_ILO1_END;
